import React, { useState, useEffect } from 'react';
import getChartData from '../services/dataService';
import ChartistGraph from 'react-chartist';
import "../../src/libs/chartist.min.css";

const Chart = ({ title, service, caption }) => {

    const [rangeVal, setRangeVal] = useState(10);
    const [data, setData] = useState({});

    


    useEffect(() => {
        console.log("Component useEffect for "+service);
        getChartData(service, rangeVal).then((r) => {
            setData(r);
        });
    }, []);

    const handleChange = async e => {

        setRangeVal(e.target.value);

        var response = await getChartData(service, e.target.value);

        setData(response);

    }

    var type = 'Line';
    var options = {
        fullWidth: true,
        chartPadding: { top: 0, right: 30, left: 0, bottom: 0 }
    };

    return (
        <div className="chart-component">

            <h1>{title}</h1>
            <div><h2>{caption} in the last {rangeVal} days</h2></div>

            <ChartistGraph data={data} options={options} type={type}/>

            <div className="slidecontainer">
                <input type="range" value={rangeVal} min="10" max="30"
                    onChange={handleChange}
                    className="slider" />
            </div>
           
        </div>
    );
}        
                                
                                



export default  Chart;